import Cookies from 'js-cookie/src/js.cookie';

export const announcementBar = (): void => {
  const announcementBar = document.querySelector('[data-announcement-bar]')
  const header = document.querySelector('[data-header]')
  const htmlEl = document.querySelector('html');
  const filters = document.querySelector('.horizontal-filters');

  if (!announcementBar) return;

  const closeIcon = announcementBar.querySelector('[data-announcement-bar-close]');

  if (window.innerWidth <= 767) {
    closeIcon.addEventListener('click', () => {
      Cookies.set('announcementBarDismissed', 'true')
      header.classList.remove('announcement-bar-active')
      htmlEl.classList.add('announcement-bar-hidden')
      return
    })
  
    if (Cookies.get('announcementBarDismissed') === 'true') {
      header.classList.remove('announcement-bar-active')
      htmlEl.classList.add('announcement-bar-hidden')
    }

    let lastKnownPosition = window.scrollY;
    window.addEventListener('scroll', () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;


      if (scrollTop > lastKnownPosition) {
        htmlEl.classList.add('header-hidden')
        header.classList.add('header-section--hidden')
        filters.classList.add('horizontal-filters--hidden')

        if (Cookies.get('announcementBarDismissed') !== 'true') {
          htmlEl.classList.add('announcement-bar-hidden')
          header.classList.remove('announcement-bar-active')
        }

      } else if (scrollTop < lastKnownPosition && scrollTop !== 0) {
        htmlEl.classList.remove('header-hidden')
        header.classList.remove('header-section--hidden')
        filters.classList.remove('horizontal-filters--hidden')

      } else if (scrollTop <= 0) {
        htmlEl.classList.remove('header-hidden')
        header.classList.remove('header-section--hidden')
        filters.classList.remove('horizontal-filters--hidden')

        if (Cookies.get('announcementBarDismissed') !== 'true') {
          htmlEl.classList.remove('announcement-bar-hidden')
          header.classList.add('announcement-bar-active')
        }

      }
      lastKnownPosition = scrollTop <= 0 ? 0 : scrollTop;
    })
  } else {
    return
  }

}